import { Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';
import { Layout } from './components/Layout';
import { NotFoundPage, routeDefs, type RouteParams } from './routes';

/** The single app tree, rendered identically by the prerender step and the browser. */
export function App({ ssrPath }: { ssrPath?: string }) {
  return (
    <Router ssrPath={ssrPath}>
      <Layout>
        <Suspense fallback={<div className="min-h-[60vh]" aria-busy="true" />}>
          <Switch>
            {routeDefs.map(({ pattern, component: Page }) => (
              <Route key={pattern} path={pattern}>
                {(params) => <Page params={params as RouteParams} />}
              </Route>
            ))}
            <Route>
              <NotFoundPage params={{}} />
            </Route>
          </Switch>
        </Suspense>
      </Layout>
    </Router>
  );
}
